export class CreateMechanicalManagement {
    ManagementMechanical: string=''
    IsActive: boolean
}

export class EditMechanicalManagement{
    id: any
    ManagementMechanical: string=''
    IsActive: boolean
}